import Section, { SectionProps } from "./Section/Section";
import { Container, Heading, Title, Subtitle, RelatedWrapper } from "./styles";
import { useRouter } from "next/router";
import { useRef } from "react";
import { useTranslation } from "@/lib/translations";

type Props = {
  sections: SectionProps[];
  product: any;
};

const RelatedProductsSections: React.FC<Props> = (props) => {
  const { product, sections } = props;
  const { locale = "it" } = useRouter();
  const t = {
    relatedTitle: useTranslation("ProductDetail.relatedTitle", locale) || "",
    relatedSubTitle:
      useTranslation("ProductDetail.relatedSubTitle", locale) || "",
  };

  const headingRef = useRef<HTMLDivElement>(null);

  return (
    <Container>
      <Heading ref={headingRef}>
        <Title>{t.relatedTitle}</Title>
        <Subtitle>{t.relatedSubTitle}</Subtitle>
      </Heading>
      <RelatedWrapper>
        {sections?.map((section, index) => (
          <Section
            key={`${section._id}-${index}`}
            product={product}
            section={section}
            headingRef={headingRef}
          />
        ))}
      </RelatedWrapper>
    </Container>
  );
};

export default RelatedProductsSections;
